export const isProperSegment = (segmentName = '') =>
  !!segmentName &&
  segmentName !== 'Top 10' &&
  segmentName !== 'Top 25' &&
  segmentName !== 'Score Changed' &&
  !segmentName.toLowerCase().startsWith('all');
